import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'lns-sidebar-header',
  templateUrl: './sidebar-header.component.html',
  styleUrls: ['./sidebar-header.component.scss']
})
export class SidebarHeaderComponent {
  @Output() deleteHandler = new EventEmitter();
  @Input() onBackRoute: string | undefined;
  @Input() deleteIcon = false;

  constructor(private router: Router, private route: ActivatedRoute) {}

  onBack(): void {
    if (this.onBackRoute) {
      this.router.navigate([this.onBackRoute], { relativeTo: this.route });
    } else {
      this.router.navigate(['../'], { relativeTo: this.route });
    }
  }

  onDelete(): void {
    this.deleteHandler.emit();
  }
}
